










import {Component, Prop, Vue} from 'vue-property-decorator'
import OptionSelector from "@/components/OptionSelector/OptionSelector.vue";

@Component({
    components: {OptionSelector}
})
export default class ItemOptionSelector extends Vue {
    private onChange(id: number): void {
        this.$emit("selectDelete");
    }
}
